import {
  CompanyLoadingAction,
  COMPANY_LOADING,
  UpdateCompanyAction,
  EDIT_COMPANY,
  GetCompanyAction,
  GET_COMPANY,
  GetTokenAction,
  GET_TOKEN,
  ErrorAction,
  ERROR
} from './actions'
import initialState from './initialState'
import moment from 'moment'

const reducer = (
  state = initialState,
  action:
    | UpdateCompanyAction
    | CompanyLoadingAction
    | ErrorAction
    | GetCompanyAction
    | GetTokenAction
) => {
  switch (action.type) {
    case COMPANY_LOADING:
      return Object.assign({}, state, {
        loading: action.loading
      })
    case ERROR:
      return Object.assign({}, state, {
        error: action.error,
        loading: action.loading
      })
    case EDIT_COMPANY:
      return Object.assign({}, state, {
        company: action.payload.data,
        loading: action.loading
      })
    case GET_COMPANY:
      return Object.assign({}, state, {
        company: action.payload.data,
        loading: action.loading
      })
    case GET_TOKEN:
      const authTokenExpiry = moment().add(action.payload.data.expires_in, 's')
      const procore = {
        ...state.company.procore,
        authToken: action.payload.data.access_token,
        authTokenExpiry
      }
      return Object.assign({}, state, {
        company: {
          ...state.company,
          procore
        },
        loading: action.loading
      })
    default:
      return state
  }
}

export default reducer
